(() => {
  const formatCaption = (material, lining) => material.label + ' · podszewka ' + lining.label;
  function init(root) {
    const configEl = root.querySelector('[data-organizer-config]');
    if (!configEl) return;
    const data = JSON.parse(configEl.textContent);
    // Стартовое состояние берём от первого доступного варианта товара, иначе
    // конфигуратор открывался бы на сочетании, которого нет на складе.
    // Разовые цвета, которых больше не будет, прячем сразу как кончились.
    // Постоянные (restock) остаются видимыми и в нуле — их довезут.
    const _all = data.variants || [];
    const _visible = _all.filter(function (v) { return v.available || v.restock; });
    data.variants = _visible.length ? _visible : _all;
    const _first = data.variants.filter(function (v) { return v.available; })[0]
      || data.variants[0];
    const state = _first
      ? { material: String(_first.material).toUpperCase(), lining: String(_first.lining).toUpperCase() }
      : { material: data.materials[0].code, lining: data.linings[0].code };
    const materialGrid = root.querySelector('[data-material-grid]');
    const liningGrid = root.querySelector('[data-lining-grid]');
    const materialBadge = root.querySelector('[data-material-badge]');
    const liningBadge = root.querySelector('[data-lining-badge]');
    const previews = root.querySelectorAll('[data-preview-image]');
    const captions = root.querySelectorAll('[data-preview-caption]');
    const propMaterial = root.querySelector('[data-prop-material]');
    const propLining = root.querySelector('[data-prop-lining]');
    const propVendor = root.querySelector('[data-prop-vendor]');
    const byMaterial = new Map(data.materials.map(item => [item.code, item]));
    const byLining = new Map(data.linings.map(item => [item.code, item]));
    function renderMaterials() {
      // Показываем только то, что заведено вариантами товара: продаём со склада,
      // шитьё под заказ не предлагаем. Список вариантов приходит из секции.
      var _codes = (data.variants || []).map(function (v) { return String(v.material || '').toUpperCase(); });
      var _mats = _codes.length
        ? data.materials.filter(function (m) { return _codes.indexOf((m.code || '').toUpperCase()) >= 0; })
        : data.materials;
      materialGrid.innerHTML = _mats.map(item => '<button class="organizer-zipm-material" type="button" data-material="' + item.code + '" aria-label="' + item.label + '"><img src="' + item.swatch + '" alt="' + item.label + '" loading="lazy"></button>').join('');
      materialGrid.querySelectorAll('[data-material]').forEach(button => {
        button.addEventListener('click', () => {
          state.material = button.dataset.material;
          // У разных материалов свой набор подшивок, поэтому список
          // перерисовываем, а выбор сбрасываем на существующий.
          const allowed = (data.variants || [])
            .filter(function (v) { return String(v.material).toUpperCase() === state.material; })
            .map(function (v) { return String(v.lining).toUpperCase(); });
          if (allowed.length && allowed.indexOf(state.lining) < 0) state.lining = allowed[0];
          renderLinings();
          update();
        });
      });
    }
    function renderLinings() {
      var _forMat = (data.variants || []).filter(function (v) {
        return String(v.material || '').toUpperCase() === String(state.material || '').toUpperCase();
      }).map(function (v) { return String(v.lining || '').toUpperCase(); });
      var _lins = _forMat.length
        ? data.linings.filter(function (l) { return _forMat.indexOf((l.code || '').toUpperCase()) >= 0; })
        : data.linings;
      liningGrid.innerHTML = _lins.map(item => '<button class="organizer-zipm-lining" type="button" data-lining="' + item.code + '" aria-label="' + item.label + '"><span style="background:' + item.css + '"></span></button>').join('');
      liningGrid.querySelectorAll('[data-lining]').forEach(button => {
        button.addEventListener('click', () => { state.lining = button.dataset.lining; update(); });
      });
    }
    function update() {
      const material = byMaterial.get(state.material);
      const lining = byLining.get(state.lining);
      const combo = data.combos[state.material + '-' + state.lining];
      root.querySelectorAll('[data-material]').forEach(btn => btn.classList.toggle('is-active', btn.dataset.material === state.material));
      root.querySelectorAll('[data-lining]').forEach(btn => btn.classList.toggle('is-active', btn.dataset.lining === state.lining));
      if (materialBadge) materialBadge.textContent = material.badge;
      if (liningBadge) liningBadge.textContent = lining.badge;
      if (combo) previews.forEach(preview => { preview.src = combo.preview; });
      captions.forEach(caption => { caption.textContent = formatCaption(material, lining); });
      if (propMaterial) propMaterial.value = material.label;
      if (propLining) propLining.value = lining.label;
      if (propVendor) propVendor.value = combo ? combo.vendorCode : '';

      // Ключевое: в корзину уходит ИМЕННО выбранный вариант. Раньше форма
      // всегда слала первый доступный, и заказ на серый списывал чёрный.
      const picked = (data.variants || []).find(function (v) {
        return String(v.material).toUpperCase() === state.material
          && String(v.lining).toUpperCase() === state.lining;
      });
      const idInput = root.querySelector('[data-organizer-form] input[name="id"]');
      if (idInput && picked) idInput.value = picked.id;
      const submit = root.querySelector('.organizer-zipm-submit');
      if (submit) {
        const ok = Boolean(picked && picked.available);
        submit.disabled = !ok;
        submit.classList.toggle('is-sold-out', !ok);
        submit.setAttribute('aria-disabled', ok ? 'false' : 'true');
        submit.textContent = ok ? submit.dataset.labelAvailable || submit.textContent : 'Brak w magazynie';
      }
    }
    renderMaterials(); renderLinings(); update();
  }
  function initGallery(root) {
    const galleryEl = root.querySelector('[data-organizer-gallery-json]');
    const galleries = root.querySelectorAll('[data-organizer-gallery]');
    if (!galleryEl || !galleries.length) return;
    const items = JSON.parse(galleryEl.textContent);
    galleries.forEach(gallery => {
      const main = gallery.querySelector('[data-gallery-main]');
      const thumbs = gallery.querySelector('[data-gallery-thumbs]');
      const prev = gallery.querySelector('[data-gallery-prev]');
      const next = gallery.querySelector('[data-gallery-next]');
      if (!main || !thumbs) return;
      let activeIndex = 0;
      thumbs.innerHTML = items.map((item, i) => '<button type="button" class="organizer-zipm-thumb' + (i === 0 ? ' is-active' : '') + '" data-gallery-index="' + i + '"><img src="' + (item.thumb || item.src) + '" alt="' + item.alt + '" loading="lazy"></button>').join('');
      function setActive(index) {
        activeIndex = Math.max(0, Math.min(items.length - 1, index));
        const item = items[activeIndex];
        if (!item) return;
        main.src = item.src; main.alt = item.alt;
        const activeButton = thumbs.querySelector('[data-gallery-index="' + activeIndex + '"]');
        thumbs.querySelectorAll('.organizer-zipm-thumb').forEach(btn => btn.classList.toggle('is-active', btn === activeButton));
        if (activeButton) {
          const targetLeft = activeButton.offsetLeft - thumbs.offsetLeft;
          thumbs.scrollTo({ left: targetLeft, behavior: 'smooth' });
        }
        if (prev) prev.disabled = activeIndex === 0;
        if (next) next.disabled = activeIndex === items.length - 1;
      }
      thumbs.querySelectorAll('[data-gallery-index]').forEach(button => {
        button.addEventListener('click', () => setActive(Number(button.dataset.galleryIndex)));
      });
      if (prev) prev.addEventListener('click', () => setActive(activeIndex - 1));
      if (next) next.addEventListener('click', () => setActive(activeIndex + 1));
      setActive(0);
    });
  }
  function initTabs(root) {
    const tabs = root.querySelector('[data-organizer-tabs]');
    if (!tabs) return;
    const buttons = tabs.querySelectorAll('[data-tab-button]');
    const panels = tabs.querySelectorAll('[data-tab-panel]');
    buttons.forEach(button => {
      button.addEventListener('click', () => {
        const id = button.dataset.tabButton;
        buttons.forEach(item => item.classList.toggle('is-active', item === button));
        panels.forEach(panel => panel.classList.toggle('is-active', panel.dataset.tabPanel === id));
      });
    });
  }
  document.querySelectorAll('[data-organizer-zipm]').forEach(root => { init(root); initGallery(root); initTabs(root); });
})();
